"use client"

import {Basket} from "../../context/basket";
import {useSearchParams} from 'next/navigation'
import {Suspense, useContext, useEffect, useState} from "react";
import Why from '../model/elements/why';
import Spinner from "../../layout/loader";
import * as React from "react";
import Upsales from '../model/upsales';
import SimpleItemsProvider from '../model/elements/api/simpleItems';
import Summary from '../model/elements/summary';
import '../../../styles/4-pages/_6-basket.scss';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import SubscriptionUpdateMode from "../../customiser/components/update";
import {useRouter} from "next/navigation";
import Ga4 from '../../components/tags/ga4';

export default function BasketPage() {
    const basket = useContext(Basket);
    const [searchParams, setSearchParams] = useState(null);
    const [entrantReferrer, setEntrantReferrer] = useState(null);
    const [loader, setLoader] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState("Loading Basket...");
    const [showUpdateNotification, setShowUpdateNotification] = useState(false);
    const [basketUpdated, setBasketUpdated] = useState(false);
    const entrantRef = React.useRef(entrantReferrer);
    const [sentTag, setSentTag] = useState(false);
    const [hasPushedState, setHasPushedState] = useState(false);
    const [showUpsaleTitle, setShowUpsaleTitle] = useState(false);
    const { push } = useRouter();

    useEffect(() => {
        document.body.classList.remove("customiser");
        if (typeof basket?.data?.is_sub_update !== 'undefined'
            && basket?.data?.is_sub_update === true) {
            setShowUpdateNotification(true);
        }

        if (typeof basket?.data?.shopify_entrant_referrer !== 'undefined'
            && entrantReferrer !== basket?.data?.shopify_entrant_referrer) {
            setEntrantReferrer(basket?.data?.shopify_entrant_referrer);
            entrantRef.current = basket?.data?.shopify_entrant_referrer;
        }

        if (basket?.data?.quote?.quote && sentTag === false) {
            setSentTag(true);
            Ga4('view_cart', basket?.data);
        }

        // Make sure the basket is up-to-date when it first loads.
        if (!basketUpdated) {
            setLoader(true);
            setLoadingMessage('Updating basket...');
            basket.updateBasketReturn().then(() => {
                setBasketUpdated(true);
            });
        }
    }, [basket, entrantReferrer]);

    const shouldShow = () => {
        if (loader === false) {
            return {display: 'block'}
        }

        return {display: 'none'}
    }

    const InstantiateSearch = () => {
        const searchParams = useSearchParams();
        if (searchParams !== null) {
            let google = searchParams.get('_gl');
            let impact = searchParams.get('im_ref');
            let redirect = '/basket';
            if (impact !== null) {
                redirect += '?im_ref=' + impact;
            }
            if (google !== null) {
                redirect += '&_gl=' + google;
            }

            redirect = (impact === null && google === null) ? redirect += '?entry=true' : redirect += '&entry=true';
            window.history.pushState({}, '', redirect);
            window.addEventListener('popstate', function(event) {
                if (typeof entrantRef.current !== 'undefined' && entrantRef.current !== null) {
                    window.location.href = entrantRef.current;
                }
            });
        }
    }

    const loadingClass = () => {
        if (loader) {
            return 'basket-page-wrapper loading';
        }

        return 'basket-page-wrapper';
    }

    return <div className={loadingClass()}>
            {loader && (
                <Spinner loadingMessage={loadingMessage} />
            )}
            {showUpdateNotification && (
                <SubscriptionUpdateMode />
            )}
            {!loader && (
                <Box className="bg-darken-lt-grey padding-y-4 padding-tablet-y-1  padding-tablet-bottom-3" style={shouldShow()}>
                    <Suspense fallback={<>Loading, please wait...</>}>
                        <InstantiateSearch />
                    </Suspense>
                    <Grid container>
                        <Grid xs={12} md={3} className="basket-sidebar mobile-hide">
                            <Box className="padding-left-4 padding-tablet-left-2 full-height space-between">
                                <Box className="padding-desktop-right-5">
                                    <h1 className="margin-mobile-top-0 margin-desktop-top-2">Review your selection</h1>
                                    <p>You're nearly there, see why over 250,000 men trust Sons.</p>
                                </Box>
                                <Why/>
                            </Box>
                        </Grid>
                        <Grid xs={12} md={9} className="basket-contents">
                            <Box className="bg-lt-grey rounded padding-2 margin-x-4 margin-desktop-left-0 margin-tablet-x-2 margin-tablet-top-2">
                            {basket !== null
                                && typeof basket !== 'undefined' && (
                                    <Summary
                                        setLoader={setLoader}
                                        loader={loader}
                                        loadingMessage={loadingMessage}
                                        setLoadingMessage={setLoadingMessage}
                                        isRecommendation={false}
                                        key={'basket-summary'}
                                    />
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            )}
            <div className="upsell-wrapper">
                <Grid container className="basket-wrapper">
                    <Grid xss={12} xs={12} lg={3} className="charity mobile-order" />
                    <Grid xss={12} xs={12} lg={9} className="upsale-content desktop-order">
                        <div className="upsale-wrapper">
                            {basket !== null
                                && typeof basket !== 'undefined' &&
                                basket?.data?.quote?.quote && (
                                    <>
                                        {showUpsaleTitle && (
                                            <h2 className="title">
                                                You may also like...
                                            </h2>
                                        )}
                                        <SimpleItemsProvider key={'simpleData'} basket={basket.data.quote.quote} setShowUpsaleTitle={setShowUpsaleTitle} setLoader={setLoader}>
                                            <Upsales
                                                loader={loader}
                                                setLoader={setLoader}
                                                loadingMessage={setLoadingMessage}
                                                setLoadingMessage={setLoadingMessage}
                                                key={'simple-products'}
                                            />
                                        </SimpleItemsProvider>
                                    </>
                                )}
                        </div>
                    </Grid>
                </Grid>
            </div>
        </div>
}